export enum ModalButtons {
  none = 'none',
  // The message box contains Abort, Retry, and Ignore buttons.
  abortRetryIgnore = 'abortRetryIgnore',
  // The message box contains an OK button.
  ok = 'ok',
  // The message box contains OK and Cancel buttons.
  okCancel = 'okCancel',
  // The message box contains Retry and Cancel buttons.
  retryCancel = 'retryCancel',
  // The message box contains Yes and No buttons.
  yesNo = 'yesNo',
  // The message box contains Yes, No, and Cancel buttons.
  yesNoCancel = 'yesNoCancel',

  dangerYesNo = 'dangerYesNo',
  saveCancel = 'saveCancel',
  cancel = 'cancel',
  abort = 'abort',
  retry = 'retry',
  ignore = 'ignore',
  no = 'no',
  dangerYes = 'dangerYes',
  save = 'save',
  yes = 'yes'
}

export enum DialogResult {
  abort = 1,
  retry = 2,
  ignore = 3,
  ok = 4,
  cancel = 5,
  yes = 6,
  no = 7,
  close = 8,
  save = 9
}

export interface Button {
  text: string;
  dialogResult: DialogResult;
  isDanger: boolean;
}

export const ModalButtonAndText = {
  abort: {
    text: 'Abort',
    dialogResult: DialogResult.abort
  },
  retry: {
    text: 'Retry',
    dialogResult: DialogResult.retry
  },
  ignore: {
    text: 'Ignore',
    dialogResult: DialogResult.ignore
  },
  ok: {
    text: 'Ok',
    dialogResult: DialogResult.ok
  },
  cancel: {
    text: 'Cancel',
    dialogResult: DialogResult.cancel
  },
  no: {
    text: 'No',
    dialogResult: DialogResult.no
  },
  yes: {
    text: 'Yes',
    dialogResult: DialogResult.yes
  },
  dangerYes: {
    text: 'Yes',
    dialogResult: DialogResult.yes,
    danger: true
  },
  save: {
    text: 'Save',
    dialogResult: DialogResult.save,
    primary: true
  }
};
